import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { SessionMetadata } from '../../interfaces/session-metadata/session-metadata';
import { SessionMetadataForCreation } from '../../interfaces/session-metadata/session-metadata-for-creation';

@Injectable({
    providedIn: 'root'
})
export class SessionMetadataRepositoryService {
    protected _baseLink: string;

    constructor(
        private http: HttpClient,
        @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
        this._baseLink = `${this.config.rootUrl}`;
    }

    private generateHeaders = () => {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        }
    }

    public getSessionMetadata = (orderID: string): Observable<SessionMetadata[]> => {
        return this.http.get<SessionMetadata[]>(`${this._baseLink}/Orders/${orderID}/SessionMetadata`);
    }

    public createSessionMetadata = (orderID: string, sessionMetadata: SessionMetadataForCreation) => {
        return this.http.post<SessionMetadata>(`${this._baseLink}/Orders/${orderID}/SessionMetadata`, sessionMetadata, this.generateHeaders());
    }
}
